import { h } from "preact";
import omit from "lodash/omit";

import { classNames, renderIcon } from "../helpers";
import Tag from "./Tag.jsx";

export default function Checkbox({ children, ...props }) {
  const inputProps = omit(props, "class", "description");

  return (
    <label
      class={classNames(
        "checkbox",
        props.class,
        props.iconFront && "checkbox--withFrontIcon",
        props.iconBack && "checkbox--withBackIcon",
        props.inline && "checkbox--inline",
        props.leftAligned && "checkbox--leftAligned",
        props.multilinable && "checkbox--multilinable"
      )}
      for={inputProps.id}
    >
      <input class="filled-in" type="checkbox" {...inputProps} />
      <span class="checkbox__label">
        <span class="checkbox__labelInner">
          {renderIcon(props.iconFront, "checkbox__frontIcon")}
          <span class="checkbox__labelContent">{children}</span>
          <span class="checkbox__desc">{props.description}</span>
          {props.count && (
            <Tag grey noHover class="checkbox__count">
              {props.count}
            </Tag>
          )}

          {renderIcon(props.iconBack, "checkbox__backIcon")}
        </span>
      </span>
    </label>
  );
}
